<template>
  <footer v-emit-position="$_onPositionChange">
    <!--<ul>
      <li>
        <a :href="'https://www.gbrrossetto.biz/gbrB2B/'" class="no-mobile-underline-link" target="_blank">Shop</a>
      </li>
      <li
        v-for="link of links"
        :key="link.name">
        <router-link
          class="no-mobile-underline-link"
          :to="{ name: link.name }"
          @click="link.name"
          @mouseover.native="updateMouseCursor('button')"
          @mouseout.native="updateMouseCursor('default')">{{link.text}}</router-link>
      </li>
    </ul>-->
    <div>
      <p>©2018 Pololab | Capitale Sociale: Euro 100.000,00 i.v. | P. IVA e Cod. Fisc. 04748610260 | <router-link :to="{ name: 'privacy' }">Privacy Policy</router-link> | <router-link :to="{ name: 'cookie' }">Cookies Policy</router-link></p>
      <p>
        <a
          :href="'https://www.quamm.it'"
          target="_blank"
          rel="noopener"
          @mouseover="updateMouseCursor('button')"
          @mouseout="updateMouseCursor('default')">Quamm</a>
      </p>
    </div>
  </footer>
</template>

<script>
import _ from 'lodash'
import { mapMutations } from 'vuex'

export default {
  data: () => ({
    links: [
      {
        text: 'Referenze',
        name: 'clients',
        href: '/referenze'
      },
      {
        text: 'Assistenza',
        name: 'contacts',
        href: '/contatti'
      },
      {
        text: 'Contatti',
        name: 'contacts',
        href: '/contatti'
      },
      {
        text: 'Area legale',
        name: 'privacy',
        href: '/privacy-policy'
      }
    ]
  }),
  methods: {
    ...mapMutations([
      'updateFooterStatus'
    ]),
    ...mapMutations('animations', [
      'updateMouseCursor'
    ]),
    $_onPositionChange (entry) {
      this.updateFooterStatus(entry.isIntersecting)
    }
  },
  directives: {
    'emit-position': {
      bind (el, binding) {
        const observer = new window.IntersectionObserver(entries => {
          _.forEach(entries, entry => {
            binding.value(entry)
          })
        })

        observer.observe(el)
      }
    }
  }
}
</script>

<style lang="scss">

@import '../assets/scss/breakpoint.scss';

$violet: #0a2f75;
$white: #f2f2f2;
$whiteClosure: #E2DDE6;

$marginLeftRight: 6.25%;
$marginLeftRightDesktop: 3.25%;

footer{
  width: 100%;
  overflow: hidden;
  background: $violet;
  position: relative;
  z-index: 11;

  a{
    text-decoration: none;
  }
  ul{
    padding: 7.5rem $marginLeftRight;
    margin: 0;
    list-style: none;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    @include media(">=large"){
      flex-direction: row;
      padding: 15rem $marginLeftRightDesktop;
    }
  }
  li{

    &:not(:last-child){
      margin-bottom: 1.5rem;
    }
    @include media(">=large"){
      flex-direction: row;
    }

  }
  li a{
    position: relative;
    color: $white;
    font-size: 1.8rem;
    display: inline-block;
    padding-bottom: .25rem;
    transform: translate3d(0,0,0);

    &:after{
      display: block;
      content: "";
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 1px;
      background: $white;
      transform: scaleX(0);
      transform-origin: right;
      transition: transform .3s ease-out;
    }

    &:hover{
      &:after{
        transform: scaleX(1);
        transform-origin: left;
      }
    }
    @include media(">=xlarge"){
      font-size: 2.4rem;
    }
  }
  div{
    padding: 5rem $marginLeftRight;
    display: flex;
    flex-direction: column;
    p{
      font-size: 1.25rem;
      margin: 0;
      line-height: 1.7;
      color: $whiteClosure;
    }
    a{
      color: $whiteClosure;
      transition: opacity .35s;
      display: inline-block;
      &:hover{
        opacity: .75;
      }
    }
    @include media(">=large"){
      margin-top: 7.5rem;

      padding: 5rem $marginLeftRightDesktop;
      flex-direction: row;
      justify-content: space-between;

      p:first-of-type{
        max-width: 80%
      }

      a{
        margin-top: 0;
      }

    }
  }
}
</style>
